// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9JFhp","wrapper":"styles_wrapper__mLc7n"};